export const formatRouteLink = (addRoute, path = '/') => {
  return addRoute.map(route => {
    if (route.childs && route.childs.length) {
      return {
        path: path + route.menuLink,
        name: route.id.toString(),
        meta: {
          title: route.menuName,
          icon: route.menuPicSmall,
          bicon: route.menuPicBig,
        },
        children: formatRouteLink(route.childs, path + route.menuLink + '/'),
      };
    } else {
      if (route.menuCode == process.env.VUE_APP_REGISTER_DASHBOARD_CODE) {
        return {
          path: '/',
          name: route.id.toString(),
          menuCode: route.menuCode,
          meta: {
            title: '首页',
            icon: route.menuPicSmall,
            bicon: route.menuPicBig,
          },
        };
      }
      return {
        path: path + route.menuLink,
        name: route.id.toString(),
        menuCode: route.menuCode,
        meta: {
          title: route.menuName,
          icon: route.menuPicSmall,
          bicon: route.menuPicBig,
        },
      };
    }
  });
};

export const getAuthRoute = (asyncRouterMap, addRoute, path = '/') => {
  return addRoute.map(route => {
    if (route.childs && route.childs.length) {
      return {
        path: path + route.menuLink,
        component: { render: h => <router-view /> },
        name: route.id,
        meta: {
          title: route.menuName,
          icon: route.menuPicSmall,
          bicon: route.menuPicBig,
        },
        children: getAuthRoute(
          asyncRouterMap,
          route.childs,
          path + route.menuLink + '/'
        ),
      };
    } else {
      let localcomponent = asyncRouterMap.find(
        item => item.code === route.menuCode
      );
      if (localcomponent) {
        if (
          route.menuCode == process.env.VUE_APP_DASHBOARD_CODE ||
          route.menuCode == process.env.VUE_APP_REGISTER_DASHBOARD_CODE
        ) {
          return {
            path: localcomponent.path,
            component: localcomponent.component,
            name: localcomponent.name,
            menuCode: route.menuCode,
            meta: {
              ...localcomponent.meta,
              icon: route.menuPicSmall,
              bicon: route.menuPicBig,
              btns: route.listMenuButtonVo.reduce(
                (btns, val) =>
                  val.buttonCode
                    ? { ...btns, [val.buttonCode]: val.state === '1' }
                    : btns,
                {}
              ),
            },
          };
        }
        return {
          path: path + route.menuLink,
          component: localcomponent.component,
          name: route.id,
          menuCode: route.menuCode,
          meta: {
            ...localcomponent.meta,
            title: route.menuName,
            icon: route.menuPicSmall,
            bicon: route.menuPicBig,
            btns: route.listMenuButtonVo.reduce(
              (btns, val) =>
                val.buttonCode
                  ? { ...btns, [val.buttonCode]: val.state === '1' }
                  : btns,
              {}
            ),
          },
        };
      } else {
        return {
          path: path + route.menuLink,
          redirect: '/404',
          name: route.id,
          meta: {
            title: route.menuName,
            icon: route.menuPicSmall,
          },
        };
      }
    }
  });
};

export const getMenuDataById = (routeList, name) => {
  let menuData = null;
  for (let index = 0; index < routeList.length; index++) {
    const element = routeList[index];
    if (element.children && element.children.length) {
      menuData = getMenuDataById(element.children, name);
      if (menuData) break;
    } else if (element.name === name) {
      menuData = element;
      break;
    }
  }
  return menuData;
};

export const getMenuDataByCode = (allRouterMap, code) => {
  let menuData = null;
  for (let index = 0; index < allRouterMap.length; index++) {
    const element = allRouterMap[index];
    if (element.children && element.children.length) {
      menuData = getMenuDataByCode(element.children, code);
      if (menuData) break;
    } else if (element.menuCode === code) {
      menuData = element;
      break;
    }
  }
  return menuData;
};
